import React from "react";
import type { CommentAnchorType } from "../../../services/types";
import { getAnchorDisplayText } from "../../anchored-comments";
import styles from "../CanonicalCommentWorkspace.module.css";

type AnchorContextCardProps = {
  anchor: CommentAnchorType | null;
  onResolve?: (anchorId: number) => Promise<void>;
  onReopen?: (anchorId: number) => Promise<void>;
};

export const AnchorContextCard: React.FC<AnchorContextCardProps> = ({
  anchor,
  onResolve,
  onReopen,
}) => {
  if (!anchor) return null;

  const canResolve = anchor.status === "ACTIVE" && Boolean(onResolve);
  const canReopen = anchor.status === "RESOLVED" && Boolean(onReopen);

  return (
    <aside className={styles.anchorContextCard} aria-label="Anchored discussion context">
      <div>
        <span>Anchored discussion</span>
        <strong>{anchor.status.toLowerCase()}</strong>
      </div>
      <blockquote>“{getAnchorDisplayText(anchor)}”</blockquote>
      {(canResolve || canReopen) && (
        <div className={styles.anchorContextActions}>
          {canResolve && (
            <button type="button" onClick={() => onResolve?.(anchor.id)}>
              Resolve
            </button>
          )}
          {canReopen && (
            <button type="button" onClick={() => onReopen?.(anchor.id)}>
              Reopen
            </button>
          )}
        </div>
      )}
    </aside>
  );
};
